import React from "react";
import Box from "@mui/material/Box";
import { IconButton, Tooltip, Modal } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModalHeader from "./ModalHeader";

const ViewAttendanceModal = ({ selectedImage, closeImageModal, open }) => {
 console.log("Selected Image:", selectedImage);
  return (
    <>
      <Modal
        open={open}
        onClose={closeImageModal}
        aria-labelledby="image-modal"
        aria-describedby="modal-to-view-attendance-image"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: "70%", md: "50%", lg: "40%" },
            maxWidth: "800px",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            outline: 'none'
          }}
        >
          <ModalHeader title="Attendance Image" handleClose={closeImageModal} />
          <Box 
            sx={{ 
              textAlign: "center",
              maxHeight: '80vh',
              overflow: 'auto'
            }}
          >
            {selectedImage ? (
              <img
                style={{ 
                  width: "100%", 
                  height: "auto",
                  borderRadius: 1,
                  maxHeight: '75vh'
                }}
                src={selectedImage}
                alt="Attendance selfie"
              />
            ) : (
              <Box sx={{ p: 4 }}>Loading image...</Box>
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ViewAttendanceModal;